// Compute axle layout based on num_tyres & vehicle type.
// Returns array of axles: each axle = { positions: [{ id: 'P1', side: 'L' }, ...] }
// Convention: label positions L1, L2, R1, R2 per axle. For 1-per-side: L, R.

export function computeLayout(numTyres, vehicleType) {
  const axles = [];
  let remaining = numTyres;
  let axleIdx = 1;

  if (vehicleType === "truck") {
    // steer axle 2 tyres (1L, 1R)
    axles.push({
      idx: 1,
      positions: [
        { id: "1L", side: "L", subIdx: 1 },
        { id: "1R", side: "R", subIdx: 1 },
      ],
    });
    remaining -= 2;
    axleIdx = 2;
    // handle 4-per-axle for the rest
    while (remaining >= 4) {
      axles.push({
        idx: axleIdx,
        positions: [
          { id: `${axleIdx}L1`, side: "L", subIdx: 1 },
          { id: `${axleIdx}L2`, side: "L", subIdx: 2 },
          { id: `${axleIdx}R1`, side: "R", subIdx: 1 },
          { id: `${axleIdx}R2`, side: "R", subIdx: 2 },
        ],
      });
      remaining -= 4;
      axleIdx += 1;
    }
    // if remaining 2 leftover, add a single-tyre axle
    if (remaining === 2) {
      axles.push({
        idx: axleIdx,
        positions: [
          { id: `${axleIdx}L`, side: "L", subIdx: 1 },
          { id: `${axleIdx}R`, side: "R", subIdx: 1 },
        ],
      });
      remaining -= 2;
    }
  } else {
    // trailer: dual axles (4-per-axle) if numTyres divisible by 4; else 2-per-axle
    if (numTyres % 4 === 0) {
      const nAxles = numTyres / 4;
      for (let i = 1; i <= nAxles; i++) {
        axles.push({
          idx: i,
          positions: [
            { id: `${i}L1`, side: "L", subIdx: 1 },
            { id: `${i}L2`, side: "L", subIdx: 2 },
            { id: `${i}R1`, side: "R", subIdx: 1 },
            { id: `${i}R2`, side: "R", subIdx: 2 },
          ],
        });
      }
    } else {
      // 2 per axle
      const nAxles = numTyres / 2;
      for (let i = 1; i <= nAxles; i++) {
        axles.push({
          idx: i,
          positions: [
            { id: `${i}L`, side: "L", subIdx: 1 },
            { id: `${i}R`, side: "R", subIdx: 1 },
          ],
        });
      }
    }
  }
  return axles;
}
